// extracted by mini-css-extract-plugin
export default {"prosthetic":"ProstheticsPage_prosthetic__vOuDy"};